import React from "react";
import { Route } from "react-router";
import { Redirect, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "src/pages/support/Login";
import {
  supportIsAccountant,
  supportIsLoggedIn,
} from "src/store/support/selector";
import Support from "src/layouts/Support";
import ForcedLightTheme from "src/components/ForcedLightTheme";
import Token from "src/pages/support/Token";
import User from "src/pages/support/User";
import EBayLimits from "src/pages/support/EBayLimits";
import EtsyLimits from "src/pages/support/EtsyLimits";
import ClientVersions from "src/pages/support/ClientVersions";
import LoadTimings from "src/pages/support/LoadTimings";
import SalesDates from "src/pages/support/SalesDates";
import Errors from "src/pages/support/Errors";
import ErrorAlerts from "src/pages/support/ErrorAlerts";
import { ErrorAlertsDefaultPath } from "src/pages/support/errorAlertsUrlState";

function SupportRouter() {
  const isLoggedIn = useSelector(supportIsLoggedIn);
  const isAccountant = useSelector(supportIsAccountant);

  // Accountants authenticate through the same support token flow but must
  // never see the internal support tools.
  if (isLoggedIn && isAccountant) return <Redirect to="/accountant" />;

  if (!isLoggedIn) {
    return (
      <ForcedLightTheme>
        <Login />
      </ForcedLightTheme>
    );
  }

  return (
    <ForcedLightTheme>
      <Support>
        <Switch>
          <Route path="/support/client-versions" component={ClientVersions} />
          <Route path="/support/load-timings" component={LoadTimings} />
          <Route path="/support/sales-dates" component={SalesDates} />
          <Route path="/support/errors" component={Errors} />
          <Route
            exact
            path="/support/error-alerts"
            render={() => <Redirect to={ErrorAlertsDefaultPath} />}
          />
          <Route
            path="/support/error-alerts/:timeWindow/:alertId?"
            component={ErrorAlerts}
          />
          <Route path="/support/ebay-limits" component={EBayLimits} />
          <Route path="/support/etsy-limits" component={EtsyLimits} />
          <Route path="/support/user/:uid?" component={User} />
          <Route component={Token} />
        </Switch>
      </Support>
    </ForcedLightTheme>
  );
}

export default SupportRouter;
